import { registerLocaleData } from '@angular/common';
import localeDutch from '@angular/common/locales/de';
import localeEn from '@angular/common/locales/en';
import localeFinnish from '@angular/common/locales/fi';
import localeNorwegian from '@angular/common/locales/nb';
import localeNatherland from '@angular/common/locales/nl';
import { Injectable } from '@angular/core';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { ThemesService } from 'projects/Autofacets-Core/src/app/services/themes.service';
import { SecureStorage } from '../../../../Autofacets-Core/src/app/common-services/SecureStorage.service';
import { Constant } from '../../../../Autofacets-Core/src/app/utils/constant';
import { CultureCodes } from '../../../../Autofacets-Core/src/app/utils/enums';
import { CommonLocalizationService } from './common-localization.service';
import { UtilityServices } from './utility.services';
import { EnvSetting } from 'projects/Autofacets-Core/src/app/utils/env-setting';
import { GlobalSetting } from 'projects/Autofacets-Core/src/app/common-services/global-setting.service';
import { ClientAppToken } from 'projects/Autofacets-Core/src/app/utils/env-setting';
import { environment } from 'projects/Check-In/src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CultureLocaleService {

  constructor(
    private commonLocalizationService: CommonLocalizationService,
    private secureStorage: SecureStorage,
    private utilityServices: UtilityServices,
    private currentLanguage: CurrentLanguage,
    private themservice: ThemesService,
    private globalSetting: GlobalSetting
  ) { }

  private _locale: string;
  private cultureCode: string;
  public currencyCode: string;
  private timeZone: string;
  globalizationValues: any;

  async initialise() {
    this.cultureCode = Constant.defaultISOCultureCode;
    EnvSetting.BRAND_API_URL = `${environment.CHECKIN_API_URL}Setting/BrandLogo`;
    if (ClientAppToken()) {
      await this.commonLocalizationService.GetSettings().then(async (res) => {
        await this.LoadConfig(res.responseObject);
      });
    }
    else {
      await this.commonLocalizationService.GetGenericSettings().then(async (res) => {
        await this.LoadConfig(res.responseObject);
      });
    }
  }
  private async LoadConfig(response: any) {
    if (response) {
      this.globalizationValues = response;
      if (this.globalizationValues && this.globalizationValues.length > 0) {
        this.globalSetting.MapAppSetting(this.globalizationValues);
        let LicencePlateClass = this.globalizationValues.filter(x => x.property === 'LicencePlateClass');
        this.secureStorage.setKeyData('LicencePlateClass', LicencePlateClass[0].value);
        let tenant = this.globalizationValues.filter(x => x.property === 'Tenant');
        localStorage.setItem('Theme', tenant[0].value);
        let cultureCodeValue = this.globalizationValues.filter(x => x.property === 'CultureCode');

        if (cultureCodeValue) {
          this.cultureCode = cultureCodeValue[0].value;
          this.currentLanguage.cultureCodeSubject.next(cultureCodeValue[0].value);
          this.secureStorage.setKeyData('CultureCode', cultureCodeValue[0].value);
        }
        let timeZoneValue = this.globalizationValues.filter(x => x.property === 'TimeZoneStandardName');
        if (timeZoneValue) {
          this.timeZone = timeZoneValue[0].value;
          this.currentLanguage.timeZoneStandradName.next(timeZoneValue[0].value);
          this.secureStorage.setKeyData('TimeZoneStandradName', timeZoneValue[0].value);
        }
        let logo = this.globalizationValues.filter(x => x.property === 'LogoUrlLink');
        this.secureStorage.setKeyData('LogoUrlLink', logo[0].value);
        let TermsConditionData = this.globalizationValues.filter(x => x.property === 'TermsCondiData');
        this.secureStorage.setKeyData('TermsConditionData', TermsConditionData[0].value);
        if (tenant?.[0]?.value) {
          this.themservice.themeInitializer();
        }
        this.registerCulture(this.cultureCode);
        this.currencyCode = this.utilityServices.getCurrencyCode(this.cultureCode);
      }
    }
  }

  getLocaleEN() {
    this._locale = 'en'
    registerLocaleData(localeEn, 'en');
  }
  getLocale(): string {
    return this._locale || 'en';
  }

  registerCulture(culture: string) {
    switch (culture) {
      case CultureCodes.NB_NO: {
        this._locale = 'no'
        registerLocaleData(localeNorwegian, 'no');
        break;
      }
      case CultureCodes.EN_US: {
        this._locale = 'en'
        registerLocaleData(localeEn, 'en');
        break;
      }
      case CultureCodes.FI_FI: {
        this._locale = 'fi'
        registerLocaleData(localeFinnish, 'fi');
        break;
      }
      case CultureCodes.NL_NL: {
        this._locale = 'nl'
        registerLocaleData(localeNatherland, 'nl');
        break;
      }
      case CultureCodes.DE_DE: {
        this._locale = 'de'
        registerLocaleData(localeDutch, 'de');
        break;
      }
      default:
        this.getLocaleEN();
    }
  }
}
